<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="450px">
            <v-card>
                <v-card-title>
                    <div style="width: 100%">
                        <p class="text-right pointer" @click="closeModal()">X</p>
                        <p class="headline text-center">
                            {{ this.$vuetify.lang.t('$vuetify.employee.lineRegisCode') }}
                        </p>
                    </div>
                </v-card-title>
                <v-card-text class="card-padding">
                    <div class="margin-between-container">
                        <label>{{ this.$vuetify.lang.t('$vuetify.employee.regisCode') }}</label>
                        <v-text-field
                            v-model="form.code"
                            solo
                            autocomplete="off"
                            append-icon="mdi-content-copy"
                            @click:append="copyCode()"
                            readonly
                        >
                        </v-text-field>
                    </div>
                    <div class="d-flex flex-column align-center">
                        <qrcode-vue
                            v-if="form.code"
                            class="d-flex justify-center margin-between-container"
                            :value="form.code"
                            :size="qrSize"
                            level="H" />
                        <div v-else class="d-flex justify-center margin-between-container">
                            <div class="empty-box"></div>
                        </div>
                        <div class="margin-between-container">
                            <div class="instruction mb-2">
                                <i class="fas fa-exclamation-square"></i> <span>{{ this.$vuetify.lang.t('$vuetify.employee.instruction') }}</span>
                            </div>
                            <div class="description-text">
                                <p class="remove-margin">{{ this.$vuetify.lang.t('$vuetify.employee.instructionOne') }}</p>
                                <p class="remove-margin">{{ this.$vuetify.lang.t('$vuetify.employee.instructionTwo') }}</p>
                                <p class="remove-margin"><span class="star-color">* </span>{{ this.$vuetify.lang.t('$vuetify.employee.genNewQrWarning') }}
                                </p>
                            </div>
                        </div>
                        <v-btn
                            height="50px"
                            width="70%"
                            color="primary"
                            @click="genNewCode()">
                            {{ this.$vuetify.lang.t('$vuetify.employee.genNewCode') }}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
    name: 'LineRegisCodeModal',

    components: {
        QrcodeVue
    },
    data () {
        return {
            dialog: false,
            form: {
                code: ''
            },
            employeeId: null,
            qrSize: 184
        }
    },

    methods: {
        async openModal (employeeId) {
            this.employeeId = employeeId
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`employee/line-regis-code/${this.employeeId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.form.code = res.data.data
                this.dialog = true
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: res.data.msg,
                    type: 'notify-error'
                })
            }
        },

        copyCode () {
            navigator.clipboard.writeText(this.form.code)
        },

        closeModal () {
            this.dialog = false
        },

        async genNewCode () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post(`employee/line-regis-code/${this.employeeId}/create`)
            if (res && res.data && res.data.status === 'ok') {
                this.form.code = res.data.data
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: res.data.msg,
                    type: 'notify-error'
                })
            } else {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: this.$vuetify.lang.t('$vuetify.employee.tryAgain'),
                    type: 'notify-error'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-padding {
    padding: 2rem 3rem !important;
}
.empty-box {
    width: 184px;
    height: 184px;
    background-color: grey;
}

.remove-margin {
    margin-bottom: 0;
}

.margin-between-container {
    margin-bottom: 24px;
}

.description-text {
    font-size: 14px;
    color: #131410;
    font-weight: normal;
}

.star-color {
    color: #ff544a;
}

.instruction {
    color: #6c98ba;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    background-color: #f8f8f8;
    box-shadow: none !important;
}
</style>
